import { LoginState } from '../types';

export const loginState: LoginState = {
  isAuthUser: false,
  isRequestPending: false,
  notification: {
    type: null,
    message: '',
  },
  preferredLanguage: 'en',
};
